<div [ngClass]="ngClass" *ngIf="!dismissed">
  <mat-card *ngIf="heading" class="m-0 p-0 fade-container" [ngClass]="ngClass">
    <mat-toolbar
      class="quick-card fw-light"
      [color]="color"
      (click)="collapsable ? collapsed = !collapsed : collapsed = false; toggleExpandCollapse.emit(collapsed) "
      [ngClass]="{ 'click-able': collapsable }"
    >
      <ng-container
        *ngIf="headingPrefixTemplate"
        [ngTemplateOutlet]="headingPrefixTemplate"
      ></ng-container>
      <span>
        <mat-icon
          *ngIf="headingIconKey"
          style="vertical-align:middle;"
          class="me-1"
        >{{headingIconKey}}</mat-icon>
        {{heading}}
      </span>
      <ng-container
        *ngIf="headingSuffixTemplate"
        [ngTemplateOutlet]="headingSuffixTemplate"
      ></ng-container>
      <span class="flex-mid-spacer"></span>
      <span *ngIf="collapsable">
        <button mat-icon-button>
          <mat-icon>{{ collapsed ? 'unfold_more' : 'unfold_less' }}</mat-icon>
        </button>
      </span>
      <span *ngIf="dismissible">
        <button mat-icon-button (click)="dismissibleClick()">
          <mat-icon>close</mat-icon>
        </button>
      </span>
      <ng-container
        *ngIf="toolbarEndTemplate"
        [ngTemplateOutlet]="toolbarEndTemplate"
      ></ng-container>
    </mat-toolbar>
    <div
      [ngClass]="{ 'hover-able-container': useFlashOnHover }"
      class="fade-container" *ngIf="!collapsed">
      <ng-content></ng-content>
      <ng-container *ngIf="contentTemplate"
                    [ngTemplateOutlet]="contentTemplate"
                    [ngTemplateOutletContext]="{ content: content }"
      >
      </ng-container>
    </div>
  </mat-card>
</div>
